import { useState } from "react";

const coverData = {
  "Medical Cover": [
    {
      title: "Accidental Emergency",
      description:
        "If you are injured in an accident while traveling and require medical treatment or hospitalization, the policy will cover the medical expenses up to the maximum limit specified.",
    },
    {
      title: "Illness Expenses",
      description:
        "Unexpected illnesses during travel can lead to hospitalization. This policy reimburses hospitalization costs incurred due to serious illnesses, up to the policy’s limit.",
    },
    {
      title: "Hospitalization Allowance",
      description:
        "If you are hospitalized due to an illness or injury while traveling, you will receive a daily allowance for a specific number of days as per the policy’s terms.",
    },
    {
      title: "Physiotherapy Expenses",
      description:
        "In case of an injury during travel that requires physiotherapy, the costs for necessary physiotherapy sessions will be covered under the policy.",
    },
    {
      title: "OPD Expenses",
      description:
        "Reimbursement for outpatient medical expenses such as doctor consultations, diagnostic tests, and prescribed medications required due to illness or injury sustained during travel.",
    },
    {
      title: "Compassionate Visits",
      description:
        "If you are hospitalized while traveling, the policy covers the cost of two-way tickets for a family member to visit you during the hospital stay.",
    },
    {
      title: "Emergency Medical Evacuation",
      description:
        "In case of a medical emergency requiring urgent transportation (by air or land), the policy covers evacuation expenses as per the policy terms.",
    },
    {
      title: "Accidental Death",
      description:
        "If an accident during your travel results in death within 365 days from the incident, the insured amount will be paid to the nominee as per policy conditions.",
    },
    {
      title: "Permanent Disability",
      description:
        "If an accident during travel leads to permanent, partial, or total disability within a year of the incident, compensation is provided based on policy terms.",
    },
    {
      title: "Repatriation of Mortal Remains",
      description:
        "In case of the insured’s unfortunate demise due to injury or illness during travel, the policy covers the cost of repatriating the mortal remains to their home country.",
    },
    {
      title: "Emergency Stay & Extension",
      description:
        "If an illness, injury, or hospitalization leads to an extended stay, the policy covers additional hotel accommodation expenses up to the specified policy limit.",
    },
  ],
  "Trip Covers": [
    {
      title: "Flight Delay",
      description:
        "If your booked flight is delayed beyond the specified number of hours mentioned in the policy schedule, you will be reimbursed as per the policy’s limits.",
    },
    {
      title: "Flight Cancellation",
      description:
        "If your trip is canceled due to unavoidable reasons like an accident or hospitalization, you will be reimbursed for the costs as per the policy terms.",
    },
    {
      title: "Missed Flight",
      description:
        "If you miss your flight and book a new one within the specified time with a valid no-show certificate, the policy will compensate you as per the policy schedule.",
    },
    {
      title: "Flight Rescheduling",
      description:
        "If you need to reschedule your flight due to an accident, illness, or any other covered reason, the policy will cover the cost of booking a new flight up to the plan’s limit.",
    },
    {
      title: "Missed Connection",
      description:
        "If you miss a connecting flight due to the delay of your previous flight, the policy will cover the cost of booking a new flight as per the policy’s terms.",
    },
    {
      title: "Loss of Passport",
      description:
        "Losing a passport in a foreign country can be stressful. This travel insurance covers the application fees and documentation expenses for obtaining a duplicate passport.",
    },
  ],
  "Baggage Covers": [
    {
      title: "Delayed Baggage",
      description:
        "A few hours without your luggage can be inconvenient. If your baggage is delayed due to misplacement or other reasons, we will compensate you with a lump sum amount as per the policy terms.",
    },
    {
      title: "Lost Baggage",
      description:
        "Losing your luggage while traveling can cause major inconvenience. Our policy provides a fixed compensation for the total loss of your checked-in baggage as per the policy terms.",
    },
    {
      title: "Partial Loss",
      description:
        "Even a minor loss can be troublesome. The policy provides compensation if your checked-in baggage sustains damages that require repairs or items from your checked-in baggage are lost.",
    },
  ],
  "Add-ons": [
    {
      title: "Adventure Sports Cover",
      description:
        "For adventure lovers, this add-on provides coverage if you get injured while participating in adventure sports or winter activities. The policy will reimburse hospitalization expenses as per the specified terms.",
    },
    {
      title: "Home Burglary/Fire Insurance",
      description:
        "Worried about your home while traveling? This coverage protects against financial losses due to burglary, theft, or fire at your home while you are abroad.",
    },
    {
      title: "Emergency Hotel Accommodation",
      description:
        "If your trip extends unexpectedly due to an emergency, this add-on covers the cost of hotel accommodation for the specified duration, subject to policy terms.",
    },
    {
      title: "Bounced Booking",
      description:
        "If you are denied boarding on a flight or your hotel cancels your confirmed booking, this feature reimburses the cost of rebooking under the policy's terms.",
    },
  ],
};

export default function TravelCover() {
  const [selectedTab, setSelectedTab] = useState("Medical Cover");

  return (
    <div className="p-6 flex flex-col items-center mt-6">
    <div className="flex flex-wrap justify-center gap-3 mb-6">
      {Object.keys(coverData).map((tab) => (
        <button
          key={tab}
          className={`px-6 py-3 rounded-full text-lg font-medium transition duration-300 ease-in-out focus:ring-2 focus:ring-blue-400 
            ${selectedTab === tab ? "bg-blue-600 text-white shadow-lg" : "bg-gray-200 text-black hover:bg-gray-400"}`}
          onMouseEnter={() => setSelectedTab(tab)} // 👈 Hover instead of click
        >
          {tab}
        </button>
      ))}
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full max-w-7xl">
      {coverData[selectedTab].map((item, index) => (
        <div
          key={index}
          className="p-6 border rounded-xl bg-gray-50 shadow-lg hover:shadow-xl transition-transform transform hover:scale-105"
        >
          <h3 className="text-xl font-semibold mb-2 text-blue-700">{item.title}</h3>
          <p className="text-gray-700">{item.description}</p>
        </div>
      ))}
    </div>
  </div>
    );
  }
//     <div className="p-6 flex flex-col items-center mt-6">
//     <div className="flex flex-wrap justify-center gap-3 mb-6">
//       {Object.keys(coverData).map((tab) => (
//         <button
//           key={tab}
//           className={`px-6 py-3 rounded-full text-lg font-medium transition duration-300 ease-in-out focus:ring-2 focus:ring-blue-400 
//             ${selectedTab === tab ? "bg-blue-600 text-white shadow-lg" : "bg-gray-200 text-black hover:bg-gray-400"}`}
//           onClick={() => setSelectedTab(tab)}
//         >
//           {tab}
//         </button>
//       ))}
//     </div>
//     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full max-w-7xl">
//       {coverData[selectedTab].map((item, index) => (
//         <div key={index} className="p-6 border rounded-xl bg-gray-50 shadow-lg hover:shadow-xl transition-transform transform hover:scale-105">
//           <h3 className="text-xl font-semibold mb-2 text-blue-700">{item.title}</h3>
//           <p className="text-gray-700">{item.description}</p>
//         </div>
//       ))}
//     </div>
//   </div>
// );
// }
